const recaptchaKey = '6Lf4slspAAAAABhFkZkwF0YaWAoXk9bJPxdvxijm';

// Wait for Recaptcha to be ready
function waitForRecaptchaReady() {
    return new Promise((resolve) => {
        const checkRecaptchaReady = setInterval(() => {
            if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.enterprise !== 'undefined') {
                clearInterval(checkRecaptchaReady);
                grecaptcha.enterprise.ready(() => resolve());
            }
        }, 100); // Check every 100 milliseconds
    });
}

// Fetch the Recaptcha token
async function getRecaptchaToken(action) {
    await waitForRecaptchaReady();
    const recaptchaToken = await grecaptcha.enterprise.execute(recaptchaKey, {action: action});
    return recaptchaToken;
}


function timestamp() {
    var response = document.getElementById("g-recaptcha-response");
    if (response == null || response.value.trim() == "") {
        var elems = JSON.parse(document.getElementsByName("captcha_settings")[0].value);
        elems["ts"] = JSON.stringify(new Date().getTime());
        document.getElementsByName("captcha_settings")[0].value = JSON.stringify(elems);
    }
}

setInterval(timestamp, 500);

let isRecaptchaVerified = false;

function enableRecaptcha(token) {
    isRecaptchaVerified = true; // Set the flag to true once reCAPTCHA is verified
}

document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("leadForm");

    if (form) {
        form.addEventListener("submit", function (event) {
            if (!isRecaptchaVerified) {
                event.preventDefault(); // Prevent form submission
                console.warn("Please complete the reCAPTCHA verification before submitting the form.");
                return false;
            }
        });
    }
});